import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { Profile, UpdateProfile } from '@mp/auth/profile/domain';

/** Endgültiges Scheitern des Profil-Abrufs, serialisierbar für Action und Store. */
export interface ProfileLoadFailure {
  status: number;
  description: string;
}

export const ProfileActions = createActionGroup({
  source: 'Auth - Profile',
  events: {
    fetchProfile: emptyProps(),
    fetchProfileSuccess: props<{ profile: Profile }>(),
    /**
     * Status und Kurzbeschreibung des endgültig gescheiterten Abrufs, damit die Fehlerseite beides anzeigen
     * kann. Bewusst serialisierbar: der rohe `HttpErrorResponse` gehört nicht in den Store.
     */
    fetchProfileError: props<ProfileLoadFailure>(),

    updateProfile: props<{ dto: UpdateProfile }>(),
    updateProfileSuccess: props<{ profile: Profile }>(),
    updateProfileError: emptyProps(),
  },
});
